export enum FormMode {
  NEW,
  EDIT,
  DECIDE,
  IMPORT
}
